import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { SETTINGS_PAGE_MAX_WIDTH } from 'src/constants/uiConsts';
import { SettingsPageRow } from '.';
import { SettingsPageToolbar } from 'src/legacy/components/Settings/SettingsPageToolbar';
import {
  SettingsPageToolbarContext,
  SettingsPageToolbarContextInterface,
} from 'src/context/settingsPageToolbarContext';
import { useDrawerWidth } from 'src/features/drawer/useDrawerWidth';

const useStyles = makeStyles<Theme, { drawerWidth: number }>((theme) =>
  createStyles({
    settingsPageContent: (props) => ({
      height: 'auto',
      width: '100%',
      maxWidth: SETTINGS_PAGE_MAX_WIDTH,
      margin: '0 auto',
      // mobile devices
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(5, 2),
        overflowY: 'auto',
      },
      // tablet devices
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(5, 4.5),
      },
      // desktop devices
      [theme.breakpoints.up('md')]: {
        paddingLeft: `${props.drawerWidth + theme.spacing(10)}px`,
        paddingTop: theme.spacing(5),
      },
    }),
  }),
);
export const SettingsPageContent: React.FC = ({ children }) => {
  const drawerWidth = useDrawerWidth();
  const classes = useStyles({ drawerWidth });
  const [toolbarActions, setToolbarActions] =
    React.useState<React.ReactNode>(null);

  const toolbarContextValue =
    React.useMemo<SettingsPageToolbarContextInterface>(
      () => ({ toolbarActions, setToolbarActions }),
      [toolbarActions],
    );

  return (
    <div className={classes.settingsPageContent}>
      <SettingsPageToolbarContext.Provider value={toolbarContextValue}>
        <SettingsPageRow fullHeight description={<SettingsPageToolbar />}>
          {children}
        </SettingsPageRow>
      </SettingsPageToolbarContext.Provider>
    </div>
  );
};
